import { render } from "./TemplateCreator.vue?vue&type=template&id=ef55e3a6&scoped=true"
import script from "./TemplateCreator.vue?vue&type=script&setup=true&lang=js"
export * from "./TemplateCreator.vue?vue&type=script&setup=true&lang=js"

import "./TemplateCreator.vue?vue&type=style&index=0&id=ef55e3a6&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef55e3a6"],['__file',"src/views/sms/template/TemplateCreator.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ef55e3a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ef55e3a6', __exports__)) {
    console.log('reload')
    api.reload('ef55e3a6', __exports__)
  }
  
  module.hot.accept("./TemplateCreator.vue?vue&type=template&id=ef55e3a6&scoped=true", () => {
    console.log('re-render')
    api.rerender('ef55e3a6', render)
  })

}


export default __exports__